import { Flex, Spinner } from '@chakra-ui/react';

const AppleCallback = () => {
  return (
    <Flex
      minHeight="100vh"
      justifyContent="center"
      alignItems="center"
      backgroundColor="neutral.900"
    >
      <Spinner size="xl" color="neutral.300" />
    </Flex>
  );
};

export default AppleCallback;
